export enum APPLICATION_ENUM {
  INVITE_PORTAL = 'Invite Portal',
  REGISTRATION_PORTAL = 'Registration Portal'
}